'use client';
import * as React from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { DEFAULT_LOCALE } from 'src/constants.cjs';

export function ClientIntlProvider({
  children,
  locale = DEFAULT_LOCALE,
}: { children: React.ReactNode; locale: string }) {
  const locales = require('../locales');
  const messages = locales[locale] || locales[DEFAULT_LOCALE];

  return (
    <NextIntlClientProvider messages={messages} locale={locale}>
      {children}
    </NextIntlClientProvider>
  );
}
